import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "./ui/accordion";
import { useLanguage } from "../context/LanguageContext";

export default function ToolFAQ({ faqs }) {
  const { lang } = useLanguage();
  if (!faqs || faqs.length === 0) return null;

  return (
    <section className="mt-10" data-testid="faq-section">
      <h2
        className="text-2xl font-bold text-slate-900 mb-5"
        style={{ fontFamily: "'Outfit', sans-serif" }}
      >
        {lang === "fr" ? "Questions fréquentes" : "Frequently Asked Questions"}
      </h2>
      <Accordion type="single" collapsible className="space-y-2">
        {faqs.map((faq, i) => (
          <AccordionItem
            key={i}
            value={`faq-${i}`}
            className="border border-slate-200 rounded-xl px-1"
            data-testid={`faq-item-${i}`}
          >
            <AccordionTrigger className="px-4 py-4 font-medium text-slate-800 hover:text-blue-600 text-left text-sm sm:text-base">
              {faq.q}
            </AccordionTrigger>
            <AccordionContent className="px-4 pb-4 text-slate-600 text-sm leading-relaxed">
              {faq.a}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </section>
  );
}
